<template>
  <div>
    <div
      v-if="loading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.6); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>
            Getting Customer profile ready...
          </h3>
        </div>
      </div>
    </div>
    <div class="main-menu-content" v-if="customerDetails !== null">
      <div class="arrow_text cursor-pointer" @click="$router.go(-1)">
        <chevron-left-icon
          size="1.5x"
          class="custom-class"
          style="vertical-align: top;"
        >
        </chevron-left-icon>
        <span class="">Back</span>
      </div>
      <h1 class="mt-2 mb-3 font-regular" v-if="customerDetails">
        {{ customerDetails.first_name }} {{ customerDetails.last_name }}'s
        Profile
      </h1>

      <div class="row justify-content-center" v-if="customerDetails">
        <div class="col-md-9">
          <div class="pb-2">
            <h5 class="actions-title">
              General Information
            </h5>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="full_name">First Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="customerDetails.first_name"
                  placeholder="Full Name"
                  name="firstname"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="last_name">Last Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="customerDetails.last_name"
                  placeholder="Full Name"
                  name="lastname"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="email_address">Email Address</label>
                <input
                  type="email"
                  id="email_address"
                  class="form-control"
                  v-model.trim="customerDetails.email"
                  placeholder="Email Address"
                  name="email_address"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="phone_number">Phone Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="customerDetails.phone_number"
                  placeholder="Phone Number"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="phone_number">Existing Customer Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="customerDetails.existing_customer_number"
                  placeholder="Phone Number"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="phone_number">Existing Account Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="customerDetails.existing_account_number"
                  placeholder="Phone Number"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="phone_number">New Account Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="customerDetails.new_account_number"
                  placeholder="Phone Number"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="status">Gender</label>
                <br />
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="customerDetails.gender"
                  placeholder="Gender"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="status">Date of Birth</label>
                <br />
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="customerDetails.date_of_birth"
                  placeholder="Gender"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="status">Status</label>
                <br />
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="customerDetails.status"
                  placeholder="Gender"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="pb-2 mt-1">
            <h5 class="actions-title">
              Official Information
            </h5>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Customer Service Status</label>
                <select
                  name=""
                  class="form-control"
                  id=""
                  v-model="customerDetails.cs_status"
                  disabled
                >
                  <option value="">Please Select Status</option>
                  <option :value="null">Please Select Status</option>
                  <option value="called-customer">Called Customer</option>
                  <option value="customer-didnot-pick"
                    >Customer Did Not Answer The Call</option
                  >
                </select>
              </div>
            </div>
            <div class="col-md-6" v-if="customerDetails.cs_user">
              <div class="form-group">
                <label for="">Customer Service Representative</label>
                <input
                  type="text"
                  :value="
                    `${customerDetails.cs_user.first_name}` +
                      ' ' +
                      `${customerDetails.cs_user.last_name}`
                  "
                  class="form-control"
                  disabled
                />
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="">Customer Service Comment</label>
                <textarea
                  disabled
                  name=""
                  class="form-control"
                  v-model="customerDetails.cs_comment"
                  style="resize: none"
                  id=""
                  cols="30"
                  rows="4"
                ></textarea>
              </div>
            </div>

            <div class="col-12 px-2">
              <button @click.prevent="openModal" class="btn btn-primary w-100">
                Treat Customer Onboarding Status
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-show="isModalVisible" @close="closeModal" footer>
      <template v-slot:title>
        <h5>Treat Customer Onboarding Status</h5>
      </template>
      <template v-slot:body>
        <div class="form-group">
          <label for="">Customer Service Status</label>
          <select name="" class="form-control" id="" v-model="cs_status">
            <option value="">Please Select Status</option>
            <option value="called-customer">Called Customer</option>
            <option value="customer-didnot-pick"
              >Customer Did Not Answer The Call</option
            >
          </select>
        </div>
        <div class="form-group">
          <label for="">Customer Service Comment</label>
          <textarea
            name=""
            class="form-control"
            v-model="cs_comment"
            style="resize: none"
            id=""
            cols="30"
            rows="4"
          ></textarea>
        </div>
      </template>
      <template v-slot:footer>
        <button
          @click.prevent="treatCustomer"
          class="btn btn-primary"
          :disabled="formLoading || (cs_comment === '' && cs_status === '')"
        >
          <span v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span>
              Please Wait...
            </span>
          </span>
          <span v-else>
            Treat Customer
          </span>
        </button>
        <button class="btn btn-secondary" @click.prevent="closeModal">
          Cancel
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";
export default {
  name: "SingleOnboard",
  props: {
    slug: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    psSettings() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction === "rtl",
        wheelPropagation: false
      };
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  data() {
    return {
      loading: true,
      formLoading: false,
      customerDetails: null,
      cs_comment: "",
      cs_status: "",
      isModalVisible: false
    };
  },
  methods: {
    async treatCustomer() {
      this.formLoading = true;
      try {
        const response = await ApiService.post("onboarding/update-cs-status", {
          hash: this.customerDetails.hash,
          cs_comment: this.cs_comment,
          cs_status: this.cs_status
        });
        this.formLoading = false;
        this.closeModal();

        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getOnboard();
      } catch (error) {
        this.closeModal();
        this.formLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    openModal() {
      this.cs_comment = "";
      this.cs_status = "";
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    async getOnboard() {
      try {
        const response = await ApiService.get(`onboarding/view/${this.slug}`);
        console.log(response);
        this.customerDetails = response.data.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error.response);
      }
    }
  },
  mounted() {
    this.getOnboard();
  }
};
</script>

<style scoped></style>
